export const NAME_snapRotationThreshold = "snapRotationThreshold";
export const NAME_snapRotationDegrees = "snapRotationDegrees";
export const NAME_snapHorizontalThreshold = "snapHorizontalThreshold";
export const NAME_snapVerticalThreshold = "snapVerticalThreshold";
